import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const isAuthenticated = await this.authService.isAuthenticated();

    if (!isAuthenticated) {
      // Redirect to login if the user is not authenticated
      return this.router.createUrlTree(['/login'], {
        queryParams: { returnUrl: state.url },
      });
    }

    // Check if the user is an admin
    const isAdmin = await this.authService.isAdmin();

    if (isAdmin) {
      return true; // Grant access
    }

    // Redirect to home if the user is not an admin
    return this.router.createUrlTree(['/home']);
  }
}
